import { render, staticRenderFns } from "./AcculatePoint.vue?vue&type=template&id=479a4390&scoped=true&"
import script from "./AcculatePoint.vue?vue&type=script&lang=js&"
export * from "./AcculatePoint.vue?vue&type=script&lang=js&"
import style0 from "./AcculatePoint.vue?vue&type=style&index=0&id=479a4390&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479a4390",
  null
  
)

export default component.exports